@if (isEmpty$ | async) {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}
<div class="container" #container>
  <img [src]="preview$ | async" #img1 />
  <img [src]="preview$ | async" #img2 />
</div>
